var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13261_7427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 0H0V100H100V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13261_7427)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2862 19.3363L62.6562 23.175C62.9977 23.475 63.4097 23.6836 63.8539 23.7816L69.5401 25.0345C70.4221 25.2288 71.1477 25.8516 71.4705 26.6921L73.553 32.1103C73.7157 32.5335 73.9837 32.909 74.3315 33.2011L78.7872 36.9411C79.4782 37.5213 79.8307 38.4083 79.7249 39.3011L79.0424 45.0571C78.9891 45.5068 79.0514 45.9628 79.2235 46.3823L81.4279 51.7528C81.7696 52.5858 81.6682 53.5335 81.1577 54.2741L77.8667 59.05C77.6097 59.4231 77.4522 59.8551 77.409 60.3058L76.8569 66.0761C76.7712 66.9715 76.2392 67.7626 75.441 68.1815L70.2957 70.8826C69.8937 71.0936 69.5524 71.403 69.3037 71.7818L66.1219 76.6303C65.6284 77.3823 64.7874 77.836 63.8844 77.8371L58.0632 77.845C57.6085 77.8455 57.1617 77.9611 56.7645 78.1811L51.6817 80.9971C50.8934 81.4338 49.9364 81.4458 49.1354 81.029L43.972 78.3415C43.5687 78.1315 43.1185 78.0273 42.664 78.038L36.8447 78.1761C35.942 78.1976 35.0882 77.7653 34.5727 77.0258L31.25 72.2588C30.9905 71.8866 30.6402 71.5858 30.2322 71.385L25.0097 68.8138C24.1995 68.415 23.6444 67.6375 23.5327 66.7448L22.8117 60.9906C22.7554 60.5411 22.5854 60.1126 22.3175 59.7463L18.888 55.0548C18.356 54.327 18.2269 53.3823 18.5442 52.5411L20.5904 47.1175C20.7502 46.6938 20.7992 46.2363 20.7327 45.7881L19.882 40.0511C19.75 39.1613 20.0764 38.266 20.7502 37.6688L25.0945 33.8183C25.4339 33.5175 25.6909 33.1358 25.841 32.7085L27.764 27.2401C28.0622 26.3918 28.7692 25.751 29.6454 25.5346L35.2927 24.1395C35.7339 24.0306 36.1397 23.8116 36.4722 23.5033L40.7282 19.5565C41.3884 18.9441 42.3142 18.7045 43.1917 18.9185L48.8484 20.2985C49.2902 20.4061 49.7522 20.4006 50.1909 20.2818L55.8049 18.7603C56.6759 18.5243 57.6084 18.7408 58.2862 19.3363Z",
    fill: "#F9C510"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4479 60.7053C46.4478 60.7054 46.4478 60.7055 45.2103 59.468L46.4478 60.7055L45.2103 61.9429L34.6162 51.3488L37.0911 48.8739L45.2103 56.9932L50.8493 51.354C54.5781 47.6252 58.8878 43.3154 61.2117 40.9915L63.6866 43.4663C61.3627 45.7903 57.053 50.1001 53.3242 53.8289L46.4479 60.7053Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13261_7427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 94,
    height: 94
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H97V97H3V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13261_7427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6689 5.88203C48.6689 5.40482 48.6689 5.11499 48.6689 5.11499",
    stroke: "#F9C510",
    strokeWidth: 11.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7471 92.4566C48.7471 92.4566 48.7471 92.1668 48.7471 91.6896",
    stroke: "#F9C510",
    strokeWidth: 11.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6113 48.7467C92.0885 48.7467 92.3784 48.7467 92.3784 48.7467",
    stroke: "#F9C510",
    strokeWidth: 11.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03711 48.825C5.03711 48.825 5.32694 48.825 5.80415 48.825",
    stroke: "#F9C510",
    strokeWidth: 11.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0732 79.0958C79.4107 79.4333 79.6156 79.6382 79.6156 79.6382",
    stroke: "#F9C510",
    strokeWidth: 11.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8008 17.9336C17.8008 17.9336 18.0057 18.1385 18.3432 18.476",
    stroke: "#F9C510",
    strokeWidth: 11.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0176 18.4207C79.355 18.0832 79.56 17.8783 79.56 17.8783",
    stroke: "#F9C510",
    strokeWidth: 11.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8555 79.6935C17.8555 79.6935 18.0604 79.4886 18.3978 79.1511",
    stroke: "#F9C510",
    strokeWidth: 11.28,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.0651210ae44ea4ce4fac7ae1342ae176.svg";
export { ForwardRef as ReactComponent };